import { days } from "@signal/asp-data-commons";
import { ShopMaxPerTime } from "../../shared/models/slot-management.model";

export const enrichShopMaxSlots = (data: ShopMaxPerTime) => {
    if (data.slotsPerDay && data.slotsPerDay.length < 7) {
        days.forEach(day => {
            if (!data.slotsPerDay.map(x=>x.dayOfWeek).includes(day)){
              data.slotsPerDay.push({dayOfWeek: day, slots: []});
            }
          });
    }
    return data;
  }